import { configureStore } from "@reduxjs/toolkit";

import globalReducer from "@/store/globalSlice";

export function makeStore() {
  return configureStore({
    reducer: {
      global: globalReducer,
    },
  });
}

export type AppStore = ReturnType<typeof makeStore>;
export type RootState = ReturnType<AppStore["getState"]>;
export type AppDispatch = AppStore["dispatch"];
